import React, {useContext, useEffect, useReducer, useState} from 'react';
import {createReducer} from "@reduxjs/toolkit";
import styles from "./NkuConfigurator.styl";
import iekGroupLogo from './images/iek.png';
import jQuery from "jquery";

const ContextApp = React.createContext(null);

const FP_REGEXP = /YKM40D-FO-PVS-(\d+)-(\d+).*/; // FORMAT Фальш-панель внутр. глухая комп. XXXX (2шт/компл) IEK

const BOX_HEIGHT = [2000];
const BOX_WIDTH  = [600, 800, 1000];
const BOX_DEPTH  = [600, 800];

const AV_PROPS = [
	{label: 'Тип АВ', name: 'type'},
	{label: 'Номинальный ток, А', name: 'current'},
	{label: 'Тип установки', name: 'installation'},
	{label: 'Тип секционирования', name: 'partitioning'},
	{label: 'Тип ориентации', name: 'orientation'},
	{label: 'Количество полюсов', name: 'poles'}
];

let db = null;

const initialState = {
	dbLoaded: false,

	nextBoxId: 2,

	selectedBoxId: 'box_1',

	view: 'top',
	viewParams: {
		showDoors: true
	},

	items: null,

	specQnt: {},

	boxes: {
		'box_1': {
			name: 'Шкаф № 1',

			height: 2000,
			width: 800,
			depth: 600,

			x: 0,
			y: 0,

			rotate: 0,

			up: null,
			down: null,
			left: null,
			right: null,

			sides: {
				left: [],
				right: [],
				base: [],
				back: [],
				dopacc: [],
				vnut: [],
				front: []
			},
		}
	}
};

function moveBoxes(state, box) {
	if (box.right) {
		state.boxes[box.right].x = box.x + box.width;
		moveBoxes(state, state.boxes[box.right]);
	}
	if (box.down) {
		state.boxes[box.down].x = box.x;
		moveBoxes(state, state.boxes[box.down]);
	}
}

function moveBoxesDepth(state, box) {
	if (box.down) {
		state.boxes[box.down].y = box.y + box.depth;
		moveBoxesDepth(state, state.boxes[box.down]);
	}
}

function getNeighbourBox(state, box, neighbour) {
	const nmap = {
		u: 'up',
		d: 'down',
		l: 'left',
		r: 'right'
	};

	const dir = nmap[neighbour.charAt(0)];

	if (!box[dir]) {
		return null;
	}

	if (neighbour.length === 1) {
		return box[dir];
	}

	return getNeighbourBox(state, state.boxes[box[dir]], neighbour.substring(1));
}

const reducer = createReducer(initialState, {
	DB_LOADED: (state, action) => {
		state.dbLoaded = true;
	},

	VIEW_CHANGE: (state, action) => {
		state.view = action.payload;
	},

	VIEW_CHANGE_PARAM: (state, action) => {
		state.viewParams[action.payload.name] = action.payload.value;
	},

	SET_ITEMS: (state, action) => {
		state.items = action.payload;
	},

	BOX_ADD: (state, action) => {
		const sbId = state.selectedBoxId;
		const sb = state.boxes[sbId];
		const { dir } = action.payload;

		const nboxId = 'box_' + state.nextBoxId;

		const newBox = JSON.parse(JSON.stringify(sb));
		newBox.name = 'Шкаф № ' + state.nextBoxId;
		newBox.up = newBox.down = newBox.left = newBox.right = null;

		if (dir === 'right') {
			newBox.left = sbId;
			newBox.x = sb.x + sb.width;
			newBox.y = sb.y;
			newBox.rotate = sb.rotate;
			sb.right = nboxId;

			let nb = getNeighbourBox(state, sb, 'dr');
			if (nb) {
				state.boxes[nb].up = nboxId;
				newBox.down = nb;
			}

			nb = getNeighbourBox(state, sb, 'ur');
			if (nb) {
				state.boxes[nb].down = nboxId;
				newBox.up = nb;
			}

			nb = getNeighbourBox(state, sb, 'drru');
			if (nb) {
				state.boxes[nb].left = nboxId;
				newBox.right = nb;
			}

			nb = getNeighbourBox(state, sb, 'urrd');
			if (nb) {
				state.boxes[nb].left = nboxId;
				newBox.right = nb;
			}

			sb.sides.right = [];
			newBox.sides.left = [];

		} else if (dir === 'down') {
			newBox.up = sbId;
			newBox.x = sb.x;
			newBox.y = sb.y + sb.depth;
			newBox.rotate = 0;
			sb.down = nboxId;
			sb.rotate = 180;

			let nb = getNeighbourBox(state, sb, 'ld');
			if (nb) {
				state.boxes[nb].right = nboxId;
				newBox.left = nb;
			}

			nb = getNeighbourBox(state, sb, 'rd');
			if (nb) {
				state.boxes[nb].left = nboxId;
				newBox.right = nb;
			}

		} else if (dir === 'left') {
			newBox.right = sbId;
			newBox.x = sb.x - sb.width;
			newBox.y = sb.y;
			newBox.rotate = sb.rotate;
			sb.left = nboxId;

			let nb = getNeighbourBox(state, sb, 'dl');
			if (nb) {
				state.boxes[nb].up = nboxId;
				newBox.down = nb;
			}

			nb = getNeighbourBox(state, sb, 'dllu');
			if (nb) {
				state.boxes[nb].right = nboxId;
				newBox.left = nb;
			}

			nb = getNeighbourBox(state, sb, 'ul');
			if (nb) {
				state.boxes[nb].down = nboxId;
				newBox.up = nb;
			}

			nb = getNeighbourBox(state, sb, 'ulld');
			if (nb) {
				state.boxes[nb].right = nboxId;
				newBox.left = nb;
			}

			sb.sides.left = [];
			newBox.sides.right = [];

		} else if (dir === 'up') {
			newBox.down = sbId;
			newBox.x = sb.x;
			newBox.y = sb.y - sb.depth;
			newBox.rotate = 180;
			sb.up = nboxId;
			sb.rotate = 0;

			let nb = getNeighbourBox(state, sb, 'lu');
			if (nb) {
				state.boxes[nb].right = nboxId;
				newBox.left = nb;
			}

			nb = getNeighbourBox(state, sb, 'ru');
			if (nb) {
				state.boxes[nb].left = nboxId;
				newBox.right = nb;
			}
		}

		if (newBox.down) {
			newBox.width = state.boxes[newBox.down].width;
		} else if (newBox.up) {
			newBox.width = state.boxes[newBox.up].width;
		}

		state.nextBoxId = state.nextBoxId + 1;
		state.boxes[nboxId] = newBox;
		state.selectedBoxId = nboxId;
	},

	BOX_SELECT: (state, action) => {
		state.selectedBoxId = action.payload;
	},

	BOX_SET_NAME: (state, action) => {
		state.boxes[state.selectedBoxId].name = action.payload;
	},

	BOX_SET_SIZE: (state, action) => {
		const sb = state.boxes[state.selectedBoxId];

		sb[action.payload.name] = action.payload.value;

		// TODO
		if (action.payload.name === 'width') {
			moveBoxes(state, sb);
		} else if (action.payload.name === 'depth') {
			moveBoxesDepth(state, sb);
		}
	},

	BOX_ROTATE: (state, action) => {
		const sb = state.boxes[state.selectedBoxId];
		sb.rotate = sb.rotate > 0 ? 0 : 180;
	},

	BOX_DEL: (state, action) => {
		const sb = state.boxes[state.selectedBoxId];

		let selectedBoxId = null;

		if (sb.left) {
			state.boxes[sb.left].right = null;
			selectedBoxId = sb.left;
		}

		if (sb.up) {
			state.boxes[sb.up].down = null;
			selectedBoxId = sb.up;
		}

		if (sb.right) {
			state.boxes[sb.right].left = null;
			selectedBoxId = sb.right;
		}

		if (sb.down) {
			state.boxes[sb.down].up = null;
			selectedBoxId = sb.down;
		}

		delete state.boxes[state.selectedBoxId];
		state.selectedBoxId = selectedBoxId;
	},

	BOX_ITEM_ADD: (state, action) => {
		const sb = state.boxes[state.selectedBoxId];
		const { type, side } = action.payload;

		sb.sides[side].push({ type, props: {}, variant: null });

		if (type === 'cokol') {
			const boxesIds = Object.keys(state.boxes);

			for (let i = 0; i < boxesIds.length; i++) {
				if (itemTypeInSide(type, state.boxes[boxesIds[i]].sides[side])) {
					continue;
				}

				state.boxes[boxesIds[i]].sides[side].push({ type, props: {}, variant: null });
			}
		}
	},

	BOX_ITEM_DELETE: (state, action) => {
		const { side, i } = action.payload;
		const type = state.boxes[state.selectedBoxId].sides[side][i].type;

		state.boxes[state.selectedBoxId].sides[side].splice(i, 1);

		if (type === 'cokol') {
			const boxesIds = Object.keys(state.boxes);

			for (let i = 0; i < boxesIds.length; i++) {
				const items = state.boxes[boxesIds[i]].sides[side];

				for (let j = 0; j < items.length; j++) {
					if (items[j].type === type) {
						items.splice(j, 1);
						break;
					}
				}
			}
		}
	},

	BOX_ITEM_MOVE: (state, action) => {
		const { side, i, dir } = action.payload;

		const sideItems = state.boxes[state.selectedBoxId].sides[side];

		const item = JSON.parse(JSON.stringify(sideItems[i]));

		if (dir === 'UP') {
			if (i === 0) {
				return;
			}

			sideItems[i] = sideItems[i - 1];
			sideItems[i - 1] = item;

		} else if (dir === 'DOWN') {
			if (i === sideItems.length - 1) {
				return;
			}

			sideItems[i] = sideItems[i + 1];
			sideItems[i + 1] = item;
		}
	},

	BOX_ITEM_SET_VARIANT: (state, action) => {
		const { side, i, variant } = action.payload;
		state.boxes[state.selectedBoxId].sides[side][i].variant = variant;
	},

	BOX_ITEM_SET_PROP: (state, action) => {
		const { side, i, prop, value } = action.payload;

		if (value) {
			state.boxes[state.selectedBoxId].sides[side][i].props[prop] = value;
		} else {
			delete state.boxes[state.selectedBoxId].sides[side][i].props[prop];
		}
	},

	SPEC_SET_QNT: (state, action) => {
		const { item, qnt } = action.payload;

		if (!state.specQnt[state.selectedBoxId]) {
			state.specQnt[state.selectedBoxId] = {};
		}

		const val = parseInt(qnt, 10);

		state.specQnt[state.selectedBoxId][item.article] = isNaN(val) ? 0 : val;
	}
});

function isCanBoxDel(box, state) {
	let cnt = 0;

	if (box.left && box.right && !box.up && !box.down) {
		return false;
	}

	if (box.right) {
		const br = state.boxes[box.right];
		if (!br.up && !br.right && !br.down) {
			cnt++;
			//return false;
		}
	}

	if (box.down) {
		const bd = state.boxes[box.down];
		if (!bd.left && !bd.right && !bd.down) {
			cnt++;
			//return false;
		}
	}

	if (box.up) {
		const bu = state.boxes[box.up];
		if (!bu.left && !bu.right && !bu.up) {
			cnt++;
			//return false;
		}
	}

	if (box.left) {
		const bl = state.boxes[box.left];
		if (!bl.left && !bl.down && !bl.up) {
			cnt++;
			//return false;
		}
	}

	return cnt < 2;
}

function isCanBoxAdd(box) {
	return {
		canAddUp: !box.up && !box.down,
		canAddDown: !box.down && !box.up,
		canAddLeft: !box.left,
		canAddRight: !box.right
	};
}

function NkuConfigurator() {
	const [state, dispatch] = useReducer(reducer, initialState);

	useEffect(() => {
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: 'nku',
				action: 'get'
			},
			_db => {
				db = _db;
				dispatch({ type: 'DB_LOADED' });
			});

		jQuery.getJSON(
			'itkcfg.php',
			{
				type: 'nku',
				action: 'getJson',
				name: 'items'
			},
			items => {
				dispatch({ type: 'SET_ITEMS', payload: items });
			});
	}, []);

	return (
		<ContextApp.Provider value={{dispatch, state}}>
			{state.dbLoaded && state.items &&
			<div className={styles.cfg}>
				<div className={styles.logo}>
					<img src={iekGroupLogo} style={{marginRight: '14px', verticalAlign: '-5px'}} height="30" alt="iek" />
					Конфигуратор подбора электротехнических шкафов FORMAT IEK
				</div>

				<div className={styles.constr}>
					<Left boxes={state.boxes} />
					<Right />

					<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '550px', height: '22px', top: '788px',left:'0'}}/>
					<a className={styles.homeLink} href={'https://www.iek.ru/'} target="_blank">На основной сайт IEK</a>

					{/* Техническая поддержка */}
					<div style={{
						position: 'absolute',
						backgroundColor: '#ffc93a',
						width: '50%',
						height: '22px',
						top: '788px',
						left: '550px'
					}}/>
					<a style={{
						position: 'absolute',
						top: '792px',
						left: '250px',
						color: '#37424a',
						width: '141px',
						height: '14px'
					}} href={'https://www.iek.ru/support/techsupport/'} target="_blank">Техническая поддержка:
					</a>
					<span className={styles.techSupport}>+7 (495) 542-22-27</span>
				</div>
			</div>
			}
		</ContextApp.Provider>
	);
}

function Left() {
	const [isShowBoxAdd, setShowBoxAdd] = useState(false);
	const {state, dispatch} = useContext(ContextApp);
	const sb = state.boxes[state.selectedBoxId];
	const { canAddUp, canAddDown, canAddLeft, canAddRight } = isCanBoxAdd(sb);
	let canBoxDel = Object.keys(state.boxes).length !== 1 && isCanBoxDel(sb, state);

	return (
		<div className={styles.left}>

			<div className={styles.leftCfg}>
				<div className={styles.buttonsTop}>
					<button onClick={() => dispatch({type: 'VIEW_CHANGE', payload: 'top'})}>Вид сверху</button>
					<button onClick={() => dispatch({type: 'VIEW_CHANGE', payload: 'front'})}>Вид спереди</button>
					<button onClick={() => dispatch({type: 'VIEW_CHANGE', payload: 'side'})}>Вид сбоку</button>
					<button onClick={() => dispatch({type: 'VIEW_CHANGE', payload: 'behind'})}>Вид сзади</button>

					<span style={{marginLeft: 100}}>{state.boxes[state.selectedBoxId].width} x {state.boxes[state.selectedBoxId].height} mm</span>
				</div>

				{['front', 'behind'].indexOf(state.view) !== -1 &&
					<div style={{position: 'absolute', top: 24, left: 0}}>
						<label><input type="checkbox" checked={state.viewParams.showDoors}
													onChange={e => dispatch({type: 'VIEW_CHANGE_PARAM',
														payload: {name: 'showDoors', value: e.target.checked}})} /> Показать двери</label>
					</div>
				}

				<Canvas />

				<div className={styles.buttons}>
					<div className={styles.btnBoxAdd} onClick={() => setShowBoxAdd(!isShowBoxAdd)} />
					<div className={styles.btnBoxRotate} onClick={() => dispatch({type: 'BOX_ROTATE'})} />
					<div className={styles.btnBoxDel} style={{opacity: canBoxDel ? '' : '50%'}} onClick={() => canBoxDel && dispatch({type: 'BOX_DEL'})} />

					<div className={styles.btnBoxAddPos} style={{display: (isShowBoxAdd ? null : 'none')}}>
						<div className={styles.btnBoxAddUp} style={{opacity: canAddUp ? '' : '50%'}} onClick={() => canAddUp && dispatch({type: 'BOX_ADD', payload: { dir: 'up' }})} />
						<div className={styles.btnBoxAddDown} style={{opacity: canAddDown ? '' : '50%'}} onClick={() => canAddDown && dispatch({type: 'BOX_ADD', payload: { dir: 'down' }})} />
						<div className={styles.btnBoxAddRight} style={{opacity: canAddRight ? '' : '50%'}} onClick={() => canAddRight && dispatch({type: 'BOX_ADD', payload: { dir: 'right' }})} />
						<div className={styles.btnBoxAddLeft} style={{opacity: canAddLeft ? '' : '50%'}} onClick={() => canAddLeft && dispatch({type: 'BOX_ADD', payload: { dir: 'left' }})} />
					</div>
				</div>
			</div>

			<Spec />
		</div>
	);
}

function Canvas() {
	const {state, dispatch} = useContext(ContextApp);
	const specUngrouped = updateSpec(state, true);

	const boxes = [];

	Object.keys(state.boxes).map(boxId =>
		boxes.push(
			<Box
				key={boxId}
				width={state.boxes[boxId].width}
				height={state.boxes[boxId].height}
				depth={state.boxes[boxId].depth}
				left={state.boxes[boxId].x}
				top={state.boxes[boxId].y}
				rotate={state.boxes[boxId].rotate}
				name={state.boxes[boxId].name}
				sides={state.boxes[boxId].sides}
				selected={state.selectedBoxId === boxId}
				view={state.view}
				viewParams={state.viewParams}
				specUngrouped={specUngrouped[boxId]}
				showRuler={!state.boxes[boxId].left && !state.boxes[boxId].down}
				onClick={() => dispatch({ type: 'BOX_SELECT', payload: boxId })}
			/>
		)
	);

	return (
		<div className={styles.canvasWrap}>
			<div className={styles.canvas}>
				{boxes}
			</div>
		</div>
	);
}

function isCanChangeBoxSize(box) {
	return {
		canChangeHeight: false,
		canChangeWidth: !box.up && !box.down,
		canChangeDepth: !box.left && !box.right
	};
}

function Right() {
	const {state, dispatch} = useContext(ContextApp);
	const sb = state.boxes[state.selectedBoxId];

	return (
		<div className={styles.right}>

			<fieldset>
				<legend>Наименование шкафа</legend>
				<input type="text" value={sb.name} onChange={e => dispatch({ type: 'BOX_SET_NAME', payload: e.target.value })} />
			</fieldset>

			<fieldset>
				<legend>Габариты шкафа</legend>
				<BoxSize />
			</fieldset>

			<fieldset>
				<legend>Фасадная сторона</legend>
				<ItemAdd side="front" />
			</fieldset>

			<fieldset>
				<legend>Левая сторона</legend>
				<ItemAdd side="left" />
			</fieldset>

			<fieldset>
				<legend>Правая сторона</legend>
				<ItemAdd side="right" />
			</fieldset>

			<fieldset>
				<legend>Задняя сторона</legend>
				<ItemAdd side="back" />
			</fieldset>

			<fieldset>
				<legend>Основание</legend>
				<ItemAdd side="base" />
			</fieldset>

			<fieldset>
				<legend>Внутреннее наполнение</legend>
				<ItemAdd side="vnut" />
			</fieldset>

			<fieldset>
				<legend>Доп. аксессуары</legend>
				<ItemAdd side="dopacc" />
			</fieldset>

		</div>
	);
}

function BoxSize() {
	const {state, dispatch} = useContext(ContextApp);
	const sb = state.boxes[state.selectedBoxId];
	const { canChangeHeight, canChangeWidth, canChangeDepth } = isCanChangeBoxSize(sb);

	return (
		<React.Fragment>
			<div>
				<label>
					Высота:
					<select disabled={!canChangeHeight}>
						{BOX_HEIGHT.map(h => <option key={h} value={h}>{h}</option>)}
					</select>
				</label>
			</div>
			<div>
				<label>
					Ширина:
					<select value={sb.width} disabled={!canChangeWidth} onChange={e => dispatch({ type: 'BOX_SET_SIZE', payload: { name: 'width', value: parseInt(e.target.value, 10) } })}>
						{BOX_WIDTH.map(w => <option key={w} value={w}>{w}</option>)}
					</select>
				</label>
			</div>
			<div>
				<label>
					Глубина:
					<select value={sb.depth} disabled={!canChangeDepth} onChange={e => dispatch({ type: 'BOX_SET_SIZE', payload: { name: 'depth', value: parseInt(e.target.value, 10) } })}>
						{BOX_DEPTH.map(d => <option key={d} value={d}>{d}</option>)}
					</select>
				</label>
			</div>
		</React.Fragment>
	);
}

function getItemPropValues(item, propName, box) {
	const propsKeys = Object.keys(item.props);
	//const allProps = db.filter['nku_' + item.type][propName];
	let props = [];

	let items = db.list['nku_' + item.type]
		.filter(_item => (
			propsKeys.every(filterPropName => (
				(_item.box_width ? parseInt(_item.box_width) === box.width : true)
				&& (
					Array.isArray(_item[filterPropName]) ?
					_item[filterPropName].indexOf(item.props[filterPropName]) !== -1
					: _item[filterPropName] === item.props[filterPropName]
				)
			))
		));

	for (let i = 0; i < items.length; i++)
	{
		if (Array.isArray(items[i][propName]))
		{
			for (let k = 0; k < items[i][propName].length; k++) {
				if (props.indexOf(items[i][propName][k]) === -1 && items[i][propName][k]) {
					props.push(items[i][propName][k]);
				}
			}
		}
		else
		{
			if (props.indexOf(items[i][propName]) === -1 && items[i][propName]) {
				props.push(items[i][propName]);
			}
		}
	}

	return props;
}

function ItemAdd({ side }) {
	const {state, dispatch} = useContext(ContextApp);
	const sb = state.boxes[state.selectedBoxId];
	const box_hwd = [sb.height, sb.width, sb.depth].join('x');

	return (
		<React.Fragment>
			<label>
				Добавить продукт
				<select value="" onChange={e => dispatch({ type: 'BOX_ITEM_ADD', payload: { side, type: e.target.value } })}>
					<option value="" />
					{Object.keys(state.items[side]).filter(itemType => !sb.sides[side].some(item => item.type === itemType && !state.items[side][itemType].multiple)).map(itemType =>
						<option key={itemType} value={itemType}>{state.items[side][itemType].name}</option>
					)}
				</select>
			</label>

			{sb.sides[side].map((item, i) => (
				<div key={i} className={styles.boxItem}>
					<div>
						<span className={styles.boxItemDelete} onClick={() => dispatch({ type: 'BOX_ITEM_DELETE', payload: { side, i } })}>X</span>
						{state.items[side][item.type].name}
					</div>

					{item.type === 'av' &&
						AV_PROPS.map(prop =>
							<label key={prop.name}>
								{prop.label}
								<select value={item.props[prop.name]} onChange={e => dispatch({ type: 'BOX_ITEM_SET_PROP', payload: { side, i, prop: prop.name, value: e.target.value } })}>
									<option />
									{getItemPropValues(item, prop.name, sb).map(prop => <option key={prop} value={prop}>{prop}</option>)}
								</select>
							</label>
						)
					}

					{'sku' in state.items[side][item.type] && !state.items[side][item.type].single &&
						<select value={state.boxes[state.selectedBoxId].sides[side][i].variant || ''} onChange={e => dispatch({ type: 'BOX_ITEM_SET_VARIANT', payload: { side, i, variant: e.target.value } })}>
							<option value="" />
							{getSkuByType(item.type, box_hwd, false, true).map(sku =>
								<option value={sku.variant} key={sku.article}>{sku.name}</option>
							)}
						</select>
					}

					{'variants' in state.items[side][item.type] &&
						<select value={state.boxes[state.selectedBoxId].sides[side][i].variant || ''} onChange={e => dispatch({ type: 'BOX_ITEM_SET_VARIANT', payload: { side, i, variant: e.target.value } })}>
							<option value="" />
							{Object.keys(state.items[side][item.type].variants).filter(variant => box_hwd in state.items[side][item.type].variants[variant].articles).map(variant => (
								<option value={variant} key={variant}>{state.items[side][item.type].variants[variant].name}</option>
							))}
						</select>
					}

					{['av', 'falsh_panel'].indexOf(item.type) !== -1 &&
					<div>
						{i !== 0 && <button onClick={() => dispatch({ type: 'BOX_ITEM_MOVE', payload: { side, i, dir: 'UP' } })}>↑</button>}
						{i !== sb.sides[side].length - 1 && <button onClick={() => dispatch({ type: 'BOX_ITEM_MOVE', payload: { side, i, dir: 'DOWN' } })}>↓</button>}
					</div>
					}
				</div>
			))}
		</React.Fragment>
	);
}

/**
 * @param {string} type
 * @param {Object[]} side
 * @param {boolean} [variant]
 */
function itemTypeInSide(type, side, variant = false) {
	return side.find( item => item.type === type && (variant ? item.variant : true) );
}

function Box({ width, height, depth, top, left, rotate, selected, sides, specUngrouped, view, viewParams, name, showRuler, onClick }) {
	const frontPanels = [];
	const specItemsCompl = specUngrouped.compl;

	let falshPanelKomp = false;
	for (let i = 0; i < specItemsCompl.length; i++)
	{
		const item = specItemsCompl[i];

		if (item.item.type === 'falsh_panel_komp') {
			falshPanelKomp = true;
		}
	}

	for (let i = 0, h = (falshPanelKomp ? 50 : 0); i < specItemsCompl.length; i++)
	{
		const item = specItemsCompl[i];

		let fpParams = FP_REGEXP.exec(item.article);

		if (fpParams) {
			const fpHeight = parseInt(fpParams[1], 10) * 10;

			if (h + fpHeight > 1900) {
				continue;
			}

			frontPanels.push({
				top: h,
				height: fpHeight
			});

			h += fpHeight;
		}
	}

	const ruler = [];
	for (let i = 0; i <= 2000; i += 200) {
		ruler.push(i);
	}
	const rulerH = [];
	for (let i = 0; i <= 4800; i += 200) {
		rulerH.push(i);
	}

	return (
		<React.Fragment>
			{['front', 'side', 'behind'].indexOf(view) !== -1 && showRuler &&
			<svg width="400" height="2100" xmlns="http://www.w3.org/2000/svg" className={styles.ruler}>
				<line stroke="black" strokeWidth="20" x1="350" y1="50" x2="350" y2="2050" />

				{ruler.map(r =>
					<React.Fragment key={r}>
						<text x="0" y={2000 - r + 100} className={styles.rulerText}>{r}</text>
						<line stroke="black" strokeWidth="10" x1="250" y1={2000 - r + 50} x2="350" y2={2000 - r + 50} />
					</React.Fragment>
				)}
			</svg>
			}

			{['top', 'front', 'behind'].indexOf(view) !== -1 && showRuler &&
			<svg width="4900" height="800" xmlns="http://www.w3.org/2000/svg" className={styles.rulerH}>
				<line stroke="black" strokeWidth="20" y1="0" x1="50" y2="0" x2="4850" />

				{rulerH.map(r =>
					<React.Fragment key={r}>
						<text x="200" y={-r} className={styles.rulerText} transform="rotate(90)">{r}</text>
						<line stroke="black" strokeWidth="10" y1="0" x1={r + 50} y2="100" x2={r + 50} />
					</React.Fragment>
				)}
			</svg>
			}

			{view === 'top' &&
				<div className={selected ? styles.boxSelected : styles.box} style={{width, height: depth, top, left, transform: `rotate(${rotate}deg)`}} title={name} onClick={onClick} />
			}

			{view === 'front' &&
				<div className={selected ? styles.boxFrontSelected : styles.boxFront} style={{ left }} title={name} onClick={onClick}>

					<div className={styles.boxFrontKrosn} style={{ width, height, top: 0, left: 0 }} />

					{frontPanels.map((fp, fpIdx) => <div key={fpIdx} className={styles.boxFrontPanel} style={{ width, height: fp.height, top: fp.top, left: 0 }} />)}

					{viewParams.showDoors && itemTypeInSide('dver', sides.front, true) &&
					<div className={styles.boxFrontDoor} style={{ width, height, top: 0, left: 0 }}>
						{itemTypeInSide('dver', sides.front, true).variant === 'metal_steklo' && <div className={styles.boxFrontDoorGlass} />}
						{itemTypeInSide('dver', sides.front, true).variant === 'metal_steklo_vent' &&
							<React.Fragment>
								<div className={styles.boxFrontDoorGlassVent} />
								<div className={styles.boxFrontDoorGlassVentLeft} />
								<div className={styles.boxFrontDoorGlassVentRight} />
							</React.Fragment>}
					</div>}

					{falshPanelKomp && <div className={styles.boxFalshPanelKomp} style={{ width, height: 50, top: 0, left: 0 }} />}

					{falshPanelKomp && <div className={styles.boxFalshPanelKomp} style={{ width, height: 50, top: height - 50, left: 0 }} />}

					{itemTypeInSide('cokol', sides.base) && <div className={styles.boxFrontCokol} style={{ width, height: 100, top: height, left: 0 }} />}
				</div>
			}

			{view === 'side' &&
				<div className={selected ? styles.boxFrontSelected : styles.boxFront} style={{left: top}} title={name} onClick={onClick}>
					<div className={styles.boxFrontKrosn} style={{ width: depth, height, top: 0, left: 0 }} />
					{itemTypeInSide('cokol', sides.base) && <div className={styles.boxFrontCokol} style={{ width: depth, height: 100, top: height, left: 0 }} />}
					{itemTypeInSide('bokovaya_panel', sides.left) && <div className={styles.boxSidePanel} style={{ width: depth, height, top: 0, left: 0 }} />}
					{itemTypeInSide('bokovaya_panel', sides.right) && <div className={styles.boxSidePanel} style={{ width: depth, height, top: 0, left: 0 }} />}
				</div>
			}

			{view === 'behind' &&
				<div className={selected ? styles.boxFrontSelected : styles.boxFront} style={{width, height, left}} title={name} onClick={onClick}>
					<div className={styles.boxFrontKrosn} style={{ width, height, top: 0, left: 0 }} />

					{viewParams.showDoors && itemTypeInSide('dver', sides.back, true) &&
					<div className={styles.boxFrontDoor} style={{ width, height, top: 0, left: 0 }}>
						{itemTypeInSide('dver', sides.back, true).variant === 'metal_steklo' &&
							<div className={styles.boxFrontDoorGlass} />}

						{itemTypeInSide('dver', sides.back, true).variant === 'metal_steklo_vent' &&
							<React.Fragment>
								<div className={styles.boxFrontDoorGlassVent} />
								<div className={styles.boxFrontDoorGlassVentLeft} />
								<div className={styles.boxFrontDoorGlassVentRight} />
							</React.Fragment>}
					</div>}

					{itemTypeInSide('cokol', sides.base) && <div className={styles.boxFrontCokol} style={{ width, height: 100, top: height, left: 0 }} />}
				</div>
			}
		</React.Fragment>
	);
}

/**
 * @param {string} article
 * @return {(Object|boolean)}
 */
function getSku(article) {
	return db.list.nku_sku.find(item => item.article === article);
}

/**
 * @param {string} type
 * @param {string} box_hwd
 * @param {(string|boolean)} [variant]
 * @param {boolean} [list]
 * @return {(Object|boolean)}
 */
function getSkuByType(type, box_hwd, variant, list) {
	const [h, w, d] = box_hwd.split('x');

	const f = item => {
		if (item.type !== type) {
			return false;
		}

		if (item.box_height && item.box_height !== h) {
			return false;
		}

		if (item.box_width && item.box_width !== w) {
			return false;
		}

		if (item.box_depth && item.box_depth !== d) {
			return false;
		}

		if (typeof(variant) !== 'undefined' && variant !== false && item.variant !== variant) {
			return false;
		}

		return true;
	};

	return list ? db.list.nku_sku.filter(f) : db.list.nku_sku.find(f);
}

/**
 * @param {string} spec
 * @param {string} type
 * @param {string} box_hwd
 * @param {number} [quantity]
 */
function addSpecByType(spec, type, box_hwd, quantity) {
	const item = getSkuByType(type, box_hwd);

	if (!item) {
		return;
	}

	addSpec(spec, item.article, quantity);
}

/**
 * @param {string} spec
 * @param {string} article
 * @param {number} [quantity]
 */
function addSpec(spec, article, quantity) {
	const item = getSku(article);

	if (!item) {
		return;
	}

	if (Array.isArray(spec))
	{
		spec.push({
			article: article,
			name: item.name,
			item
		});
	}
	else
	{
		if (spec[article]) {
			spec[article].qnt += (quantity ? quantity : 1);
		} else {
			spec[article] = {
				article: article,
				name: item.name,
				qnt: quantity ? quantity : 1,
				item
			};
		}
	}
}

/**
 * @param {Object} state
 * @param {boolean} [ungrouped]
 * @return {Object}
 */
function updateSpec(state, ungrouped = false) {
	const spec = ungrouped ? [] : {};
	const spec12 = ungrouped? [...spec]: {...spec};

	const boxesIds = Object.keys(state.boxes);

	for (let i = 0; i < boxesIds.length; i++)
	{
		const boxId = boxesIds[i];
		const box = state.boxes[boxId];
		const box_hwd = [box.height, box.width, box.depth].join('x');

		let stDop = false; // Добавлена FORMAT Стойка вертикальная доп. XXXX (2шт/компл) IEK

		spec[boxId] = {
			act: ungrouped ? [] : {},
			compl: ungrouped ? [] : {},
			dop: ungrouped ? [] : {}
		};

		const bs = spec[boxId];


		addSpecByType(bs.compl, 'stoyka', box_hwd); // FORMAT Стойка вертикальная XXXX (4шт/компл) IEK

		if (box.up) {
			addSpecByType(bs.compl, 'soed', box_hwd); // FORMAT Комплект для соединения шкафов IP54 IEK
		}

		if (box.right) {
			addSpecByType(bs.compl, 'soed', box_hwd); // FORMAT Комплект для соединения шкафов IP54 IEK
		}

		addSpecByType(bs.compl, 'krosn', box_hwd); // FORMAT Крыша и основание XXXхXXX IP54 IEK

		for (let side in {left: 1, right: 1, base: 1, front: 1, back: 1, dopacc: 1, vnut: 1})
		{
			for (let j = 0; j < box.sides[side].length; j++)
			{
				let item = null;
				let variant = null;

				if (box.sides[side][j].type === 'av')
				{
					switch (box.sides[side][j].props.type)
					{
						case 'воздушный':
							addSpecByType(bs.compl, 'reika_mont_b', `0x0x${box.width}`, 2); // FORMAT Рейка монтажная тип В XXXX IEK
							addSpecByType(bs.compl, 'reika_mont_b', `0x0x${box.depth}`, 2); // FORMAT Рейка монтажная тип В XXXX IEK
							break;
						case 'в литом корпусе':
							addSpecByType(bs.compl, 'reika_mont_b', `0x0x${box.depth}`, 4); // FORMAT Рейка монтажная тип В XXXX IEK
							break;
						case 'модульный':
							addSpecByType(bs.compl, 'reika_mont_b', `0x0x${box.width}`, 1); // FORMAT Рейка монтажная тип В XXXX IEK
							addSpecByType(bs.compl, 'reika_mont_b', `0x0x${box.depth}`, 2); // FORMAT Рейка монтажная тип В XXXX IEK
							break;
					}
				}

				if ('sku' in state.items[side][box.sides[side][j].type]) {
					if (state.items[side][box.sides[side][j].type].single) {
						item = getSkuByType(box.sides[side][j].type, box_hwd);
					} else {
						item = getSkuByType(box.sides[side][j].type, box_hwd, box.sides[side][j].variant ? box.sides[side][j].variant : '');
					}

					if (item) {
						addSpec(spec[boxId].compl, item.article);
					}
					continue;
				}

				if ('db' in state.items[side][box.sides[side][j].type])
				{
					const propsKeys = Object.keys(box.sides[side][j].props);

					let items = db.list['nku_' + box.sides[side][j].type]
						.filter(_item => (
							propsKeys.every(filterPropName => (
								(_item.box_width ? parseInt(_item.box_width) === box.width : true)
								&& _item[filterPropName] === box.sides[side][j].props[filterPropName]
							))
						));

					if (items.length !== 1) {
						continue;
					}

					if (items[0].front_panel) // Для АВ доп. стойка + панель
					{
						item = {
							article: items[0].front_panel
						};

						if (!stDop)
						{
							stDop = true;
							addSpecByType(bs.compl, 'stoyka_dop', box_hwd); // FORMAT Стойка вертикальная доп. XXXX (2шт/компл) IEK
							addSpecByType(bs.compl, 'falsh_panel_komp', box_hwd); // FORMAT Фальш-панель внутр. глухая комп. XXXX (2шт/компл) IEK
						}
					}

					if (['в литом корпусе', 'модульный'].indexOf(box.sides[side][j].props.type) !== -1 && items[0].mont_panel) // Для АВ в литом корпусе, модульный монтажная панель
					{
						addSpec(bs.compl, items[0].mont_panel);
					}
				}
				else
				{
					if ('variants' in state.items[side][box.sides[side][j].type] && box.sides[side][j].variant)
					{
						if (!('articles' in state.items[side][box.sides[side][j].type].variants[box.sides[side][j].variant])
							|| !(box_hwd in state.items[side][box.sides[side][j].type].variants[box.sides[side][j].variant].articles)) {
							continue;
						}

						variant = state.items[side][box.sides[side][j].type].variants[box.sides[side][j].variant];
						item = variant.articles[box_hwd];
					}
					else
					{
						if (!('articles' in state.items[side][box.sides[side][j].type]) || !(box_hwd in state.items[side][box.sides[side][j].type].articles)) {
							continue;
						}

						item = state.items[side][box.sides[side][j].type].articles[box_hwd];
					}
				}

				if (!item) {
					continue;
				}

				if (Array.isArray(item.article))
				{
					for (let k = 0; k < item.article.length; k++)
					{
						const _item = item.article[k];

						if (typeof _item === 'object')
						{
							addSpec(spec[boxId].compl, _item.article, _item.quantity ? _item.quantity : 1);
						}
						else
						{
							addSpec(spec[boxId].compl, _item);
						}
					}
				}
				else
				{
					addSpec(spec[boxId].compl, item.article);
				}
			}
		}
	}
	doAddToCart(spec)
	return spec;
}

function doAddToCart(items){
	const {state} = useContext(ContextApp);
	let specList={}
	for(let i in items){
		specList[i]={}
		specList[i].products=[]
		for (let x in items[i].compl){
			let count=items[i].compl[x].qnt
			if(Object.keys(state.specQnt).length!==0){
				for(let y in state.specQnt){
					if(y===i){
						for (let v in state.specQnt[y]){
							if(v===items[i].compl[x].article && state.specQnt[y][v]!==null ){
								count+=state.specQnt[y][v]
							}
						}
					}
				}
			}
			let obj={
				cnt: count,
				art: items[i].compl[x].article,
				name: items[i].compl[x].name,
			}
			let arr=specList[i].products
			arr.push(obj)
				specList[i].products=arr

		}
	 }
	const goods = JSON.stringify(specList)
	console.log(goods);
	// Отправка JSON в ipro
	window.top.postMessage(goods, '*')

}
function doPrint(params) {
	const _params = params || {};
	const $postForm = jQuery('<form action="print.php" method="post" target="_blank" accept-charset="UTF-8" />');

	let addHiddenField = function(name, value) {
		jQuery('<input type="hidden" />').attr('name', name).val(value).appendTo($postForm);
	};

	addHiddenField('type', 'nku');

	// if (this.state.item && this.state.item.article) {
	// 	addHiddenField('article', this.state.item.article);
	// }

	if (_params.data) {
		Object.keys(_params.data).forEach(dataItemName => {
			addHiddenField(dataItemName, _params.data[dataItemName]);
		});
	}

	if (_params.format) {
		addHiddenField('format', _params.format);
	}


	// if (this.props.locale) {
	// 	addHiddenField('locale', this.props.locale);
	// }

	$postForm.appendTo('body').submit().remove();
}

function Spec() {
	const {state, dispatch} = useContext(ContextApp);
	const spec = updateSpec(state);

	// Удаление дубликата боковой панели
	delDuplicates(spec);


	const onExcel = () => {
		const _spec = JSON.parse(JSON.stringify(spec));
		const sqb = Object.keys(state.specQnt);
		for (let i = 0; i < sqb.length; i++) {
			const sqba = Object.keys(state.specQnt[sqb[i]]);
			for (let j = 0; j < sqba.length; j++) {
				if (spec[sqb[i]] && spec[sqb[i]].compl[sqba[j]]) {
					_spec[sqb[i]].compl[sqba[j]].qnt += state.specQnt[sqb[i]][sqba[j]];
				}
			}
		}

		doPrint({format: 'xls', data: {
			speclist: JSON.stringify(_spec)
		}});
	};

	return (
		<div style={{backgroundColor: '#fff', padding: '10px 12px', marginTop: '10px'}}>
			<div style={{fontSize: '1.4em', marginBottom: '1em'}}>Спецификация <div className={styles.btnSpecExcel} onClick={onExcel} title="Скачать в формате Excel" /></div>

			{Object.keys(spec).map(boxId => (
				<div className={state.selectedBoxId === boxId ? styles.specItemSelected : styles.specItem} key={boxId}>
					<div style={{fontWeight: 'bold', fontSize: '1.2em', textDecoration: 'underline'}}>{state.boxes[boxId].name}</div>

					{Object.keys(spec[boxId]).map(section => Object.keys(spec[boxId][section]).length === 0 ? null : (
						<React.Fragment key={section}>
							<table>
								{section === 'act' && <caption>Активное оборудование</caption>}
								{section === 'compl' && <caption>Комплектация шкафа</caption>}
								{section === 'dop' && <caption>Дополнительная комплектация (справочно)</caption>}

								<thead>
									<tr>
										<th>Артикул</th>
										<th>Наименование</th>
										<th>Кол-во</th>
									</tr>
								</thead>
								<tbody>
									{Object.keys(spec[boxId][section]).map(article => (
										<tr key={article}>
											<td style={{whiteSpace: 'nowrap'}}>{spec[boxId][section][article].article}</td>
											<td>{spec[boxId][section][article].name}</td>
											<td>
												{spec[boxId][section][article].qnt}

												{['reika_mont_a', 'reika_mont_b'].indexOf(spec[boxId][section][article].item.type) !== -1 &&
													<label> + <input type="text" size="3"
																					 value={state.specQnt[boxId] && state.specQnt[boxId][article] ? state.specQnt[boxId][article] : 0}
																					 onChange={e => dispatch({type: 'SPEC_SET_QNT', payload: {item: spec[boxId][section][article].item, qnt: e.target.value}})} /></label>
												}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</React.Fragment>
					))}
				</div>
			))}

		</div>
	);
}

function delDuplicates(spec) {
	let compl = spec.box_1.compl;

	for (let element in compl) {
		if (compl[element].item.type === 'bokovaya_panel' && (compl[element].qnt % 2 === 0)) {
			compl[element].qnt = compl[element].qnt / 2;
		}
	}

	return spec;
}

export default NkuConfigurator;



// WEBPACK FOOTER //
// ./src/react/NkuConfigurator.jsx